<template>
  <section class="bg-white py-20 lg:py-28">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <!-- Main Grid -->
      <div class="grid lg:grid-cols-2 gap-16 items-center">
        <!-- Left - Image with Overlay Cards -->
        <div class="relative" data-aos="fade-right" data-aos-duration="1000">
          <!-- Main Image -->
          <div class="relative rounded-3xl overflow-hidden">
            <img
              src="@/assets/youthleadership.jpg"
              alt="Youth Leadership"
              class="w-full h-[500px] lg:h-[600px] object-cover"
            />
            <div
              class="absolute inset-0 bg-gradient-to-t from-logo-color/80 via-logo-color/20 to-transparent"
            ></div>
          </div>

          <!-- Floating Card -->
          <div
            class="absolute -right-6 top-1/4 bg-white rounded-2xl shadow-2xl p-5 hidden lg:block"
          >
            <div class="flex items-center gap-4">
              <div
                class="w-14 h-14 bg-green-100 rounded-xl flex items-center justify-center"
              >
                <i class="fas fa-check-circle text-green-500 text-2xl"></i>
              </div>
              <div>
                <div class="text-lg font-bold text-gray-900">Trusted</div>
                <div class="text-sm text-gray-500">By Communities</div>
              </div>
            </div>
          </div>

          <!-- Background Shape -->
          <div
            class="absolute -bottom-6 -left-6 w-full h-full border-2 border-logo-color/20 rounded-3xl -z-10"
          ></div>
        </div>

        <!-- Right - Content -->
        <div data-aos="fade-left" data-aos-duration="1000" data-aos-delay="200">
          <!-- Badge -->
          <div class="flex items-center gap-3 mb-6">
            <div class="w-12 h-[2px] bg-logo-color"></div>
            <span
              class="text-logo-color font-semibold text-sm uppercase tracking-wider"
            >
              Why Choose Us
            </span>
          </div>

          <!-- Heading -->
          <h2
            class="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-6 leading-tight"
          >
            Transforming
            <span class="text-logo-color">Youth Leadership</span>
            Across Africa
          </h2>

          <!-- Description -->
          <p class="text-gray-600 text-lg mb-10 leading-relaxed">
            We empower young people with ethical values, practical skills, and
            opportunities to become agents of positive change in their
            communities.
          </p>

          <!-- Feature List -->
          <div class="space-y-6 mb-10">
            <div class="flex items-start gap-4">
              <div
                class="w-12 h-12 bg-logo-color/10 rounded-xl flex items-center justify-center flex-shrink-0"
              >
                <i
                  class="fas fa-hand-holding-heart text-logo-color text-lg"
                ></i>
              </div>
              <div>
                <h4 class="font-bold text-gray-900 mb-1">Ethical Leadership</h4>
                <p class="text-gray-600 text-sm">
                  Building leaders with integrity and strong moral values.
                </p>
              </div>
            </div>

            <div class="flex items-start gap-4">
              <div
                class="w-12 h-12 bg-logo-color/10 rounded-xl flex items-center justify-center flex-shrink-0"
              >
                <i class="fas fa-briefcase text-logo-color text-lg"></i>
              </div>
              <div>
                <h4 class="font-bold text-gray-900 mb-1">
                  Workforce Development
                </h4>
                <p class="text-gray-600 text-sm">
                  Practical skills and training for workplace success.
                </p>
              </div>
            </div>

            <div class="flex items-start gap-4">
              <div
                class="w-12 h-12 bg-logo-color/10 rounded-xl flex items-center justify-center flex-shrink-0"
              >
                <i class="fas fa-lightbulb text-logo-color text-lg"></i>
              </div>
              <div>
                <h4 class="font-bold text-gray-900 mb-1">Entrepreneurship</h4>
                <p class="text-gray-600 text-sm">
                  Supporting innovative solutions and business creation.
                </p>
              </div>
            </div>
          </div>

          <!-- CTA Buttons -->
          <div class="flex flex-wrap gap-4">
            <button
              @click="callNow"
              class="group px-8 py-4 bg-logo-color text-white font-semibold rounded-xl hover:shadow-xl hover:shadow-logo-color/30 transition-all duration-300 flex items-center gap-3"
            >
              <i class="fas fa-phone-alt"></i>
              <span>Call Now</span>
            </button>
            <router-link
              to="/about"
              class="px-8 py-4 border-2 border-gray-200 text-gray-700 font-semibold rounded-xl hover:border-logo-color hover:text-logo-color transition-all duration-300"
            >
              Learn More
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "AdvisoryLanding",
  methods: {
    callNow() {
      window.location.href = "tel:+233249372583";
    },
  },
};
</script>

<style scoped></style>
